import React from 'react';

import Spinner from 'react-spinner';
import 'react-spinner/react-spinner.css';
import './style.scss';

import SubscribeArrow from '../../static_src/images/arrow-right-white.svg';

class MailingListSignup extends React.Component {
  state = {
    spinner: false,
    signedUp: false,
    email: ''
  };

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  addToMailingList = e => {
    e.preventDefault();
    if (this.validateEmail(this.state.email)) {
      this.setState({ spinner: true });
      fetch('/api/mailing-list/', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: this.state.email
        })
      })
        .then(r => r.json)
        .then(response => {
          this.setState({ spinner: false, signedUp: true });
        });
    }
  };

  setEmail = e => {
    this.setState({ email: e.target.value });
  };

  render() {
    if (this.state.spinner) {
      return (
        <div className="spinner-holder">
          <Spinner />
        </div>
      );
    }
    if (this.state.signedUp) {
      return <div className="signed-up">Subscribed!</div>;
    }
    return (
      <form onSubmit={this.addToMailingList}>
        <div className="subscribe-input">
          <input
            className="form-control input-sharp"
            onChange={this.setEmail}
            value={this.state.email}
            type="email"
            placeholder="Your Email"
            title="Email for Mailing List Subscription"
          />
          <button className="btn btn-red-orange btn-sharp" type="submit">
            <img alt="Subscribe button" src={SubscribeArrow} />
          </button>
        </div>
      </form>
    );
  }
}

export default MailingListSignup;
